import { render, staticRenderFns } from "./growthBonus.vue?vue&type=template&id=1749c71e&scoped=true&"
import script from "./growthBonus.vue?vue&type=script&lang=ts&"
export * from "./growthBonus.vue?vue&type=script&lang=ts&"
import style0 from "./growthBonus.vue?vue&type=style&index=0&id=1749c71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749c71e",
  null
  
)

export default component.exports